/* Qapary · comportamiento del tema. Sin dependencias. */
(function () {
  'use strict';

  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Paneles (búsqueda, menú móvil, drawers): abrir, cerrar, foco ---------- */
  const paneles = {
    abierto: null,
    ultimoFoco: null,
    abrir(id, origen) {
      const panel = document.getElementById(id);
      if (!panel) return;
      if (this.abierto && this.abierto !== panel) this.cerrar(true);
      // Si se vuelve a abrir mientras sale, la salida se cancela (su fin ve que ya no tiene la clase y no lo oculta).
      panel.classList.remove('drawer--cerrando');
      // Al cerrar, el foco vuelve a quien abrió. Si el botón estaba deshabilitado (agregando), el foco cayó en body: se usa el origen que pasa quien llama.
      const activo = document.activeElement;
      this.ultimoFoco = origen || (activo && activo !== document.body ? activo : null);
      panel.hidden = false;
      panel.setAttribute('open', '');
      document.documentElement.classList.add('panel-abierto');
      qa(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
      const foco = q('input, button, a', panel);
      if (foco) setTimeout(() => foco.focus(), 30);
      this.abierto = panel;
      // El foco queda dentro del panel abierto: Tab y Shift+Tab dan la vuelta sin salir a la página tapada.
      this.trampa = (e) => {
        if (e.key !== 'Tab') return;
        const f = qa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', panel).filter((el) => el.offsetParent !== null || el === document.activeElement);
        if (!f.length) return;
        if (!panel.contains(document.activeElement)) { e.preventDefault(); f[0].focus(); return; }
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      };
      document.addEventListener('keydown', this.trampa);
    },
    // Los drawers (menú, carrito, guía de tallas) salen con la misma animación con que entran (--dur) y recién
    // al terminar quedan hidden. Búsqueda y modales, y quien pide cerrar "inmediato", se ocultan al instante.
    cerrar(inmediato) {
      const panel = this.abierto;
      if (!panel) return;
      const ocultar = () => { panel.classList.remove('drawer--cerrando'); panel.hidden = true; panel.removeAttribute('open'); };
      const hoja = panel.classList.contains('drawer') && q('.drawer__panel', panel);
      const sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (inmediato || !hoja || sinMovimiento) ocultar();
      else {
        panel.classList.add('drawer--cerrando');
        let hecho = false;
        const fin = () => {
          if (hecho) return;
          hecho = true; clearTimeout(reloj); hoja.removeEventListener('animationend', alTerminar);
          if (panel.classList.contains('drawer--cerrando')) ocultar();
        };
        const alTerminar = (e) => { if (e.target === hoja) fin(); };
        hoja.addEventListener('animationend', alTerminar);
        const reloj = setTimeout(fin, 450); // respaldo si animationend no llega (pestaña en segundo plano)
      }
      document.documentElement.classList.remove('panel-abierto');
      qa(`[aria-controls="${panel.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
      if (this.trampa) { document.removeEventListener('keydown', this.trampa); this.trampa = null; }
      // Si quien abrió quedó apagado (por ejemplo "Talla M ya en tu carrito"), el foco va a su talla elegida o al primer control de su tarjeta.
      let volver = this.ultimoFoco;
      if (volver && volver.disabled) {
        const tarjeta = volver.closest('[data-rapido], article, li, section');
        volver = tarjeta && (tarjeta.querySelector('[aria-pressed="true"]') || tarjeta.querySelector('a[href], button:not([disabled])'));
        if (!volver && tarjeta) { tarjeta.setAttribute('tabindex', '-1'); volver = tarjeta; }
      }
      if (volver) volver.focus();
      this.abierto = null;
    },
  };
  window.qapary = window.qapary || {};
  window.qapary.paneles = paneles;
  // Mismo formato que el filtro money de Liquid (shop.money_format): el precio no cambia de aspecto al elegir talla.
  window.qapary.money = function (centavos) {
    const fmt = window.qapary.moneda || 'S/. {{amount}}';
    const conSeparadores = (valor, decimales, miles, coma) => {
      const [entero, dec] = (valor / 100).toFixed(decimales).split('.');
      return entero.replace(/\B(?=(\d{3})+(?!\d))/g, miles) + (dec ? coma + dec : '');
    };
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const tipo = m ? m[1] : 'amount';
    const monto = {
      amount: conSeparadores(centavos, 2, ',', '.'),
      amount_no_decimals: conSeparadores(centavos, 0, ',', '.'),
      amount_with_comma_separator: conSeparadores(centavos, 2, '.', ','),
      amount_no_decimals_with_comma_separator: conSeparadores(centavos, 0, '.', ','),
      amount_with_apostrophe_separator: conSeparadores(centavos, 2, "'", '.'),
    }[tipo] || conSeparadores(centavos, 2, ',', '.');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, monto);
  };

  document.addEventListener('click', (e) => {
    const abrir = e.target.closest('[data-abrir]');
    if (abrir) { e.preventDefault(); paneles.abrir(abrir.dataset.abrir); return; }
    if (e.target.closest('[data-cerrar]')) { e.preventDefault(); paneles.cerrar(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { paneles.cerrar(); cerrarMegas(); }
  });

  /* ---------- Hero: carrusel con video, avance automático y pausa ---------- */
  qa('[data-hero]').forEach((hero) => {
    const slides = qa('[data-slide]', hero);
    if (slides.length < 2) { const v = q('video', hero); if (v) v.play().catch(() => {}); return; }
    const puntos = qa('[data-punto]', hero);
    const pausa = q('[data-pausa]', hero);
    const intervalo = Math.max(3000, parseInt(hero.dataset.intervalo, 10) || 7000);
    const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    hero.style.setProperty('--hero-intervalo', `${intervalo}ms`);
    let actual = 0, timer = null, pausado = reducido, enHover = false;

    const focables = (slide, on) => qa('a, button', slide).forEach((el) => { if (on) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1'); });
    const video = (slide) => q('video', slide);

    function mostrar(n) {
      const prev = slides[actual];
      actual = (n + slides.length) % slides.length;
      const sig = slides[actual];
      if (prev !== sig) {
        prev.classList.remove('es-activa'); prev.classList.add('es-saliente');
        prev.setAttribute('aria-hidden', 'true'); focables(prev, false);
        const vp = video(prev); if (vp) { vp.pause(); }
        setTimeout(() => prev.classList.remove('es-saliente'), 1200);
      }
      sig.classList.add('es-activa'); sig.removeAttribute('aria-hidden'); focables(sig, true);
      const vs = video(sig); if (vs) { vs.currentTime = 0; vs.play().catch(() => {}); }
      puntos.forEach((p, i) => {
        p.classList.toggle('es-activo', i === actual);
        p.classList.toggle('es-visto', i < actual);
        p.setAttribute('aria-selected', i === actual ? 'true' : 'false');
      });
      // Reinicia la barra de avance del punto activo.
      const barra = q('.hero__avance', puntos[actual]);
      if (barra) { barra.style.transition = 'none'; barra.style.transform = 'scaleX(0)'; void barra.offsetWidth; barra.style.transition = ''; barra.style.transform = ''; }
      programar();
    }
    function programar() {
      clearTimeout(timer);
      if (pausado || enHover || document.hidden) return;
      timer = setTimeout(() => mostrar(actual + 1), intervalo);
    }
    function setPausa(on) {
      pausado = on;
      hero.classList.toggle('es-pausado', on);
      if (pausa) { pausa.setAttribute('aria-pressed', on ? 'true' : 'false'); pausa.setAttribute('aria-label', on ? (window.qapary.t?.hero_reanudar || 'Reanudar') : (window.qapary.t?.hero_pausar || 'Pausar')); }
      const v = video(slides[actual]); if (v) { if (on) v.pause(); else v.play().catch(() => {}); }
      programar();
    }

    puntos.forEach((p) => p.addEventListener('click', () => { mostrar(parseInt(p.dataset.punto, 10)); }));
    if (pausa) pausa.addEventListener('click', () => setPausa(!pausado));
    hero.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); mostrar(actual + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); mostrar(actual - 1); }
    });
    // Deslizar con el dedo.
    let x0 = null;
    hero.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 48) mostrar(actual + (dx < 0 ? 1 : -1));
    }, { passive: true });
    hero.addEventListener('mouseenter', () => { enHover = true; clearTimeout(timer); });
    hero.addEventListener('mouseleave', () => { enHover = false; programar(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) clearTimeout(timer); else programar(); });
    // No arrancar el reloj hasta que el hero esté a la vista (la pestaña puede abrirse en segundo plano).
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => { entries.forEach((en) => { if (en.isIntersecting) programar(); else clearTimeout(timer); }); }, { threshold: .2 });
      io.observe(hero);
    }
    // Si el navegador bloqueó el autoplay, el primer toque o clic lo destraba.
    const destrabar = () => { const v = video(slides[actual]); if (v && v.paused && !pausado) v.play().catch(() => {}); };
    ['touchstart', 'click', 'keydown'].forEach((ev) => document.addEventListener(ev, destrabar, { once: true, passive: true }));
    setPausa(pausado);
    mostrar(0);
  });

  /* ---------- Testimonios: puntos del carrusel ---------- */
  qa('[data-testimonios]').forEach((sec) => {
    const pista = q('[data-testimonios-pista]', sec);
    const puntos = qa('[data-testimonios-punto]', sec);
    if (!pista || !puntos.length) return;
    const tarjetas = qa('.testimonio', pista);
    const marcar = (i) => puntos.forEach((p, j) => { p.classList.toggle('es-activo', i === j); p.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
    const paso = () => (tarjetas[1] ? tarjetas[1].offsetLeft - tarjetas[0].offsetLeft : pista.clientWidth);
    puntos.forEach((p) => p.addEventListener('click', () => {
      pista.scrollTo({ left: parseInt(p.dataset.testimoniosPunto, 10) * paso(), behavior: 'smooth' });
    }));
    let raf = null;
    pista.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        const max = pista.scrollWidth - pista.clientWidth;
        let i = Math.round(pista.scrollLeft / paso());
        if (pista.scrollLeft >= max - 4) i = tarjetas.length - 1;
        marcar(Math.max(0, Math.min(tarjetas.length - 1, i)));
      });
    }, { passive: true });
  });

  /* ---------- Popup de bienvenida: una vez cada N días, nunca sobre un panel abierto ---------- */
  const bienvenida = q('[data-bienvenida]');
  if (bienvenida) {
    const CLAVE = 'qapary-bienvenida';
    const dias = parseInt(bienvenida.dataset.dias, 10) || 30;
    const leer = () => { try { return Number(localStorage.getItem(CLAVE)) || 0; } catch (e) { return 0; } };
    const marcar = () => { try { localStorage.setItem(CLAVE, String(Date.now())); } catch (e) { /* sin storage: se muestra una vez por visita */ } };
    const toca = Date.now() - leer() > dias * 864e5;
    let ultimoFoco = null;
    const cerrar = () => {
      bienvenida.hidden = true; document.documentElement.classList.remove('panel-abierto'); marcar();
      document.removeEventListener('keydown', teclas); if (ultimoFoco) ultimoFoco.focus();
    };
    const focables = () => qa('a[href], button, input, textarea', bienvenida).filter((el) => !el.closest('[hidden]'));
    const teclas = (e) => {
      if (e.key === 'Escape') { cerrar(); return; }
      if (e.key !== 'Tab') return;
      const f = focables(); if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    };
    const abrir = () => {
      if (paneles.abierto || document.documentElement.classList.contains('panel-abierto')) { setTimeout(abrir, 5000); return; }
      ultimoFoco = document.activeElement;
      bienvenida.hidden = false; document.documentElement.classList.add('panel-abierto');
      document.addEventListener('keydown', teclas);
      const input = q('input[type="email"]', bienvenida); if (input) setTimeout(() => input.focus(), 50);
    };
    qa('[data-bienvenida-cerrar]', bienvenida).forEach((b) => b.addEventListener('click', cerrar));
    const form = q('[data-bienvenida-form]', bienvenida);
    if (form) form.addEventListener('submit', async (e) => {
      const input = q('input[type="email"]', form), error = q('[data-bienvenida-error]', form);
      if (!input.checkValidity()) { e.preventDefault(); error.hidden = false; input.setAttribute('aria-invalid', 'true'); input.focus(); return; }
      e.preventDefault(); error.hidden = true; input.removeAttribute('aria-invalid');
      const boton = q('button[type="submit"]', form); boton.classList.add('boton--cargando');
      try {
        const res = await fetch(form.action, { method: 'POST', body: new FormData(form) });
        if (res.url.includes('/challenge')) { form.submit(); return; }
        if (!res.ok) throw new Error();
        form.hidden = true; q('[data-bienvenida-ok]', bienvenida).hidden = false; marcar();
      } catch (err) { form.submit(); }
      finally { boton.classList.remove('boton--cargando'); }
    });
    if (toca) setTimeout(abrir, parseInt(bienvenida.dataset.demora, 10) || 12000);
  }

  /* ---------- Cintas en movimiento (pijamas y barra de anuncio): frenado sutil, sin pausa ----------
     Con el mouse encima o el foco dentro, la animación CSS baja a dos tercios de su velocidad (una vuelta de 60 s
     pasa a 90 s) y vuelve al salir. Se cambia playbackRate de la animación en curso, que conserva la posición, en
     300 ms con salida suave: cambiar animation-duration en CSS haría saltar la cinta. Con movimiento reducido la
     cinta no tiene animación y esto no hace nada. */
  const FRENO = 2 / 3;
  qa('[data-cinta-frena]').forEach((zona) => {
    const pista = q('[data-cinta-pista]', zona);
    if (!pista || typeof pista.getAnimations !== 'function') return;
    let mouse = false, foco = false, raf = 0;
    const ajustar = () => {
      const anim = pista.getAnimations()[0];
      if (!anim) return;
      const desde = anim.playbackRate, hasta = mouse || foco ? FRENO : 1, t0 = performance.now();
      cancelAnimationFrame(raf);
      const paso = (t) => {
        const p = Math.min(1, (t - t0) / 300);
        anim.playbackRate = desde + (hasta - desde) * (1 - Math.pow(1 - p, 3));
        if (p < 1) raf = requestAnimationFrame(paso);
      };
      raf = requestAnimationFrame(paso);
    };
    zona.addEventListener('mouseenter', () => { mouse = true; ajustar(); });
    zona.addEventListener('mouseleave', () => { mouse = false; ajustar(); });
    zona.addEventListener('focusin', () => { if (!foco) { foco = true; ajustar(); } });
    zona.addEventListener('focusout', (e) => { if (!zona.contains(e.relatedTarget)) { foco = false; ajustar(); } });
  });

  /* ---------- Promesa de entrega hoy: cuenta regresiva en hora de Lima ---------- */
  const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  function horaLima(fecha = new Date()) {
    const partes = Object.fromEntries(new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Lima', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23', weekday: 'short' }).formatToParts(fecha).map((p) => [p.type, p.value]));
    const dia = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(partes.weekday);
    return { iso: `${partes.year}-${partes.month}-${partes.day}`, dia, minutos: Number(partes.hour) * 60 + Number(partes.minute) };
  }
  function diaConEntrega(fecha, regla, feriados) {
    const l = horaLima(fecha);
    if (feriados.includes(l.iso)) return false;
    if (regla === 'lun-vie') return l.dia >= 1 && l.dia <= 5;
    if (regla === 'lun-sab') return l.dia >= 1;
    return true;
  }
  function pintarPromesa(el) {
    const corte = Number(el.dataset.corte || 17) * 60;
    const regla = el.dataset.dias || 'lun-sab';
    const feriados = (el.dataset.feriados || '').split(',').map((x) => x.trim()).filter(Boolean);
    const titulo = q('[data-promesa-titulo]', el);
    const ahora = new Date(); const l = horaLima(ahora);
    const hoySi = diaConEntrega(ahora, regla, feriados) && l.minutos < corte;
    el.classList.toggle('es-manana', !hoySi);
    if (hoySi) {
      const falta = corte - l.minutos; const h = Math.floor(falta / 60), m = falta % 60;
      const cuanto = h > 0 ? `${h} h ${String(m).padStart(2, '0')} min` : `${m} min`;
      titulo.innerHTML = falta <= 240
        ? `Pídelo en las próximas <strong>${cuanto}</strong> y recíbelo hasta en 24 horas`
        : `Pídelo antes de las ${corte / 60 > 12 ? corte / 60 - 12 + ' p. m.' : corte / 60 + ' a. m.'} y recíbelo hasta en 24 horas`;
      return;
    }
    // Próximo día con entrega (hasta 10 días para cubrir feriados largos).
    for (let i = 1; i <= 10; i += 1) {
      const f = new Date(ahora.getTime() + i * 864e5);
      if (diaConEntrega(f, regla, feriados)) {
        titulo.innerHTML = `Pídelo antes de las ${corte / 60 > 12 ? corte / 60 - 12 + ' p. m.' : corte / 60 + ' a. m.'} y recíbelo hasta en 24 horas`;
        return;
      }
    }
  }
  // Barra de anuncio: un "llega hoy" escrito a mano se corrige fuera del día o de la hora de entrega.
  function pintarAnuncioHoy(el) {
    const corte = Number(el.dataset.corte || 17) * 60;
    const regla = el.dataset.dias || 'lun-sab';
    const feriados = (el.dataset.feriados || '').split(',').map((x) => x.trim()).filter(Boolean);
    if (!el.dataset.original) el.dataset.original = el.innerHTML;
    const ahora = new Date();
    if (diaConEntrega(ahora, regla, feriados) && horaLima(ahora).minutos < corte) { el.innerHTML = el.dataset.original; return; }
    for (let i = 1; i <= 10; i += 1) {
      const f = new Date(ahora.getTime() + i * 864e5);
      if (diaConEntrega(f, regla, feriados)) {
        el.textContent = `Pídelo antes de las ${corte / 60 > 12 ? corte / 60 - 12 + ' p. m.' : corte / 60 + ' a. m.'} y recíbelo hasta en 24 horas`;
        return;
      }
    }
  }
  const anunciosHoy = qa('[data-anuncio-hoy]');
  if (anunciosHoy.length) {
    const pintarAnuncios = () => qa('[data-anuncio-hoy]').forEach(pintarAnuncioHoy);
    pintarAnuncios();
    setInterval(pintarAnuncios, 60000);
  }

  // Siempre activo: el drawer y la página del carrito traen promesas nuevas del servidor al redibujarse (qapary-carrito.js las repinta al instante).
  const pintarTodas = () => qa('[data-promesa]').forEach(pintarPromesa);
  window.qapary.pintarPromesas = pintarTodas;
  setInterval(pintarTodas, 30000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) pintarTodas(); });
  const promesas = qa('[data-promesa]');
  if (promesas.length) {
    pintarTodas();
    // En la ficha, la promesa sigue al stock de la variante elegida.
    qa('[data-ficha]').forEach((ficha) => {
      const boton = q('[data-agregar]', ficha), promesa = q('[data-promesa]', ficha);
      if (!boton || !promesa) return;
      const sync = () => { promesa.hidden = boton.hasAttribute('data-agotado'); };
      new MutationObserver(sync).observe(boton, { attributes: true, attributeFilter: ['data-agotado'] });
      sync();
    });
    // El drawer se vuelve a renderizar: se repinta cuando cambia su contenido.
    const cuerpo = q('[data-carrito-cuerpo]');
    if (cuerpo) new MutationObserver(pintarTodas).observe(cuerpo, { childList: true });
  }

  /* ---------- Animaciones de entrada al hacer scroll ---------- */
  (function () {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const objetivos = qa('main .shopify-section').slice(1)
      .flatMap((sec) => {
        const hijos = qa('.seccion__cabecera, .cinta__cabecera, .categorias__cabecera, .imagen-texto__texto, .imagen-texto__foto, .grilla-4 > *, .categoria, .franja__item, .comunidad__item, .preguntas__item, .newsletter__interior > *', sec);
        return hijos.length ? hijos : [sec];
      })
      .filter((el) => el.getBoundingClientRect().top > window.innerHeight * 0.9);
    if (!objetivos.length) return;
    // Escalonado: los hermanos de una misma grilla entran uno tras otro.
    objetivos.forEach((el) => {
      const hermanos = el.parentElement ? Array.from(el.parentElement.children) : [];
      const i = Math.max(0, hermanos.indexOf(el));
      el.style.setProperty('--revelar-retraso', `${Math.min(i, 6) * 70}ms`);
      el.classList.add('revelar');
    });
    const io = new IntersectionObserver((entradas) => {
      entradas.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('es-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    objetivos.forEach((el) => io.observe(el));
    // Red de seguridad: si el observador no dispara (pestaña oculta, captura), todo aparece.
    setTimeout(() => objetivos.forEach((el) => el.classList.add('es-visible')), 4000);
  })();

  /* ---------- Header: se compacta al bajar ---------- */
  const cabecera = q('[data-header]') || q('header.header, .header');
  if (cabecera) {
    let ultimo = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (Math.abs(y - ultimo) < 4) return;
      document.documentElement.classList.toggle('scroll-bajo', y > 80);
      ultimo = y;
    }, { passive: true });
  }

  /* ---------- Mega menú (escritorio) ---------- */
  function cerrarMegas() {
    qa('[data-mega]').forEach((m) => { m.hidden = true; });
    qa('[data-mega-boton]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  }
  qa('[data-mega-boton]').forEach((boton) => {
    const mega = document.getElementById(boton.getAttribute('aria-controls'));
    boton.addEventListener('click', () => {
      const abierto = boton.getAttribute('aria-expanded') === 'true';
      cerrarMegas();
      if (!abierto) { mega.hidden = false; boton.setAttribute('aria-expanded', 'true'); }
    });
    const item = boton.closest('.header__item--mega');
    let timer;
    item.addEventListener('mouseenter', () => { clearTimeout(timer); cerrarMegas(); mega.hidden = false; boton.setAttribute('aria-expanded', 'true'); });
    item.addEventListener('mouseleave', () => { timer = setTimeout(cerrarMegas, 120); });
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('.header__item--mega')) cerrarMegas(); });

  /* ---------- Menú móvil por niveles ---------- */
  qa('[data-abrir-nivel]').forEach((b) => {
    b.addEventListener('click', () => {
      const hijo = document.getElementById(b.dataset.abrirNivel);
      const raiz = q('[data-nivel="0"]', b.closest('[data-niveles]'));
      if (!hijo) return;
      raiz.hidden = true; hijo.hidden = false;
      q('button, a', hijo)?.focus();
    });
  });
  qa('[data-volver-nivel]').forEach((b) => {
    b.addEventListener('click', () => {
      const hijo = b.closest('[data-nivel="1"]');
      const raiz = q('[data-nivel="0"]', b.closest('[data-niveles]'));
      hijo.hidden = true; raiz.hidden = false;
      q('button, a', raiz)?.focus();
    });
  });

  /* ---------- Búsqueda predictiva ---------- */
  const inputBusqueda = q('[data-busqueda-input]');
  const resultados = q('[data-busqueda-resultados]');
  if (inputBusqueda && resultados) {
    const t = window.qapary.t || {};
    let ultimo = '';
    let timer;
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const money = (cents) => window.qapary.money(cents);

    async function buscar(termino) {
      const url = `${window.qapary.rutas.search}/suggest.json?q=${encodeURIComponent(termino)}&resources[type]=product,collection,query&resources[limit]=4&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,variants.title,tag`;
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error(res.status);
      return (await res.json()).resources.results;
    }

    function pintar(r, termino) {
      const queries = r.queries || [], productos = r.products || [], colecciones = r.collections || [];
      if (!queries.length && !productos.length && !colecciones.length) {
        resultados.innerHTML = `<p class="busqueda__vacio">${esc((t.sin_resultados || 'No encontramos nada con __TERMS__.').replace('__TERMS__', termino))}</p>`;
        return;
      }
      const urlResultados = `${window.qapary.rutas.search}?q=${encodeURIComponent(termino)}`;
      resultados.innerHTML = `
        <div class="busqueda__grupo">
          <p class="etiqueta">${esc(t.sugerencias || 'Sugerencias')}</p>
          <ul>${queries.map((s) => `<li><a class="busqueda__sugerencia" href="${esc(s.url)}">${esc(s.text)}</a></li>`).join('')}</ul>
        </div>
        <div class="busqueda__grupo">
          <p class="etiqueta">${esc(t.productos || 'Productos')}</p>
          <ul>${productos.map((p) => `<li><a class="busqueda__producto" href="${esc(p.url)}">
              ${p.featured_image && p.featured_image.url ? `<img class="busqueda__producto-foto" src="${esc(p.featured_image.url)}&width=128" alt="" loading="lazy">` : '<span class="busqueda__producto-foto"></span>'}
              <span class="busqueda__producto-datos"><span class="cuerpo cuerpo--medio">${esc(p.title)}</span>${p.product_type ? `<span class="etiqueta">${esc(p.product_type)}</span>` : ''}</span>
              <span class="precio busqueda__producto-precio">${esc(money(p.price ? Math.round(parseFloat(p.price) * 100) : 0))}</span>
            </a></li>`).join('')}</ul>
          <a class="enlace-etiqueta" href="${esc(urlResultados)}">${esc((t.ver_resultados || 'Ver los resultados de __TERMS__').replace('__TERMS__', termino).replace(/^Ver los\s+resultados/, 'Ver los resultados'))}</a>
        </div>
        <div class="busqueda__grupo">
          <p class="etiqueta">${esc(t.colecciones || 'Colecciones')}</p>
          <ul>${colecciones.map((c) => `<li><a class="busqueda__sugerencia" href="${esc(c.url)}">${esc(c.title)}</a></li>`).join('')}</ul>
        </div>`;
    }

    inputBusqueda.addEventListener('input', () => {
      const termino = inputBusqueda.value.trim();
      clearTimeout(timer);
      if (termino.length < 2) { resultados.innerHTML = ''; ultimo = ''; return; }
      timer = setTimeout(async () => {
        if (termino === ultimo) return;
        ultimo = termino;
        try { pintar(await buscar(termino), termino); } catch (err) { resultados.innerHTML = ''; }
      }, 220);
    });
  }

  /* ---------- Toasts ---------- */
  window.qapary.toast = function (mensaje, opciones = {}) {
    const cont = q('#toasts');
    if (!cont) return;
    const el = document.createElement('div');
    el.className = `toast toast--${opciones.tono || 'exito'}`;
    el.setAttribute('role', opciones.tono === 'error' ? 'alert' : 'status');
    el.innerHTML = `<span>${mensaje}</span>${opciones.accion ? `<a class="toast__accion" href="${opciones.accion.href}">${opciones.accion.texto}</a>` : ''}<button class="toast__cerrar" type="button" aria-label="Cerrar">×</button>`;
    q('.toast__cerrar', el).addEventListener('click', () => el.remove());
    qa('.toast', cont).forEach((v) => v.remove());
    cont.appendChild(el);
    setTimeout(() => el.remove(), opciones.duracion || 6000);
  };

  /* ---------- Carrusel móvil: indicador de avance ---------- */
  qa('[data-carrusel]').forEach((car) => {
    const ind = car.parentElement.querySelector('[data-carrusel-indicador]');
    const avance = ind && q('[data-carrusel-avance]', ind);
    if (!avance) return;
    const pintar = () => {
      const total = car.scrollWidth - car.clientWidth;
      const visible = car.clientWidth / car.scrollWidth;
      avance.style.width = `${Math.max(visible * 100, 8)}%`;
      avance.style.transform = `translateX(${total > 0 ? (car.scrollLeft / total) * (100 / visible - 100) : 0}%)`;
    };
    car.addEventListener('scroll', pintar, { passive: true });
    window.addEventListener('resize', pintar);
    pintar();
  });

  /* ---------- Video con poster ---------- */
  qa('[data-video]').forEach((marco) => {
    const play = q('[data-video-play]', marco);
    const tpl = q('[data-video-embed]', marco);
    if (play && tpl) play.addEventListener('click', () => { marco.innerHTML = ''; marco.appendChild(tpl.content.cloneNode(true)); });
  });
})();

/* ---------- Filtros de colección: aplicar al cambiar ---------- */
(function () {
  const form = document.querySelector('[data-filtros]');
  if (!form) return;
  form.addEventListener('change', (e) => {
    const el = e.target;
    if (el.matches('[data-chip-todas]')) { form.querySelectorAll(`input[name="${el.dataset.chipTodas}"]`).forEach((c) => { c.checked = false; }); }
    if (el.type === 'number') return;
    if (el.name === '__todas') el.disabled = true;
    form.submit();
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('[data-filtro]')) form.querySelectorAll('[data-filtro][open]').forEach((d) => d.removeAttribute('open')); });
})();

/* ---------- Asistente de talla ---------- */
(function () {
  const raiz = document.querySelector('[data-asistente]');
  if (!raiz) return;
  const q = (s) => raiz.querySelector(s);
  const form = q('[data-asistente-form]'), resultado = q('[data-asistente-resultado]'), sin = q('[data-asistente-sin]');
  const error = q('[data-asistente-error]');
  const tallas = JSON.parse(q('[data-asistente-tallas]').textContent).map((t) => {
    const r = (s) => { const m = String(s).match(/(\d+(?:[.,]\d+)?)\D+(\d+(?:[.,]\d+)?)/); return m ? [parseFloat(m[1].replace(',', '.')), parseFloat(m[2].replace(',', '.'))] : null; };
    return { talla: t.talla, busto: r(t.busto), cintura: r(t.cintura), cadera: r(t.cadera) };
  });
  const orden = tallas.map((t) => t.talla);
  raiz.querySelectorAll('input[name="unidad"]').forEach((r) => r.addEventListener('change', () => { raiz.querySelectorAll('.asistente__unidad .chip').forEach((c) => c.classList.toggle('chip--activo', c.contains(r) && r.checked)); }));
  const mostrar = (el) => { [form, resultado, sin].forEach((x) => { x.hidden = x !== el; }); };
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    error.hidden = true;
    const unidad = form.unidad.value;
    const factor = unidad === 'in' ? 2.54 : 1;
    const medidas = {};
    const faltan = [];
    ['busto', 'cintura', 'cadera'].forEach((k) => { const v = parseFloat(form[k].value); if (!v) faltan.push(k); else medidas[k] = v * factor; });
    if (faltan.length) { error.querySelector('span').textContent = `Falta ${faltan.join(', ')}. Con las tres medidas el cálculo es fiable.`; error.hidden = false; form[faltan[0]].focus(); return; }
    const fuera = Object.entries(medidas).find(([, v]) => v < 60 || v > 160);
    if (fuera) { error.querySelector('span').textContent = `La medida de ${fuera[0]} (${Math.round(fuera[1])} cm) se sale de la tabla. Revisa la unidad: ¿centímetros o pulgadas?`; error.hidden = false; return; }
    const puntaje = tallas.map((t) => {
      let s = 0;
      ['busto', 'cintura', 'cadera'].forEach((k) => { const r = t[k]; const v = medidas[k]; if (!r) return; if (v >= r[0] && v <= r[1]) s += 0; else s += Math.min(Math.abs(v - r[0]), Math.abs(v - r[1])); });
      return s;
    });
    let idx = puntaje.indexOf(Math.min(...puntaje));
    // Si el busto queda por encima del rango de la talla elegida, sube una: la horma manda por arriba
    const t = tallas[idx];
    if (t.busto && medidas.busto > t.busto[1] && idx < tallas.length - 1) idx += 1;
    const elegida = tallas[idx];
    q('[data-asistente-talla]').textContent = elegida.talla;
    const mayor = tallas[idx + 1] ? ` Si dudas, la ${tallas[idx + 1].talla} también te va: la horma es holgada.` : '';
    q('[data-asistente-detalle]').textContent = `Con busto ${Math.round(medidas.busto)}, cintura ${Math.round(medidas.cintura)} y cadera ${Math.round(medidas.cadera)} cm, tu talla es ${elegida.talla}.${mayor}`;
    mostrar(resultado);
  });
  q('[data-asistente-sin-medidas]').addEventListener('click', () => mostrar(sin));
  raiz.querySelectorAll('[data-asistente-volver]').forEach((b) => b.addEventListener('click', () => mostrar(form)));
})();

/* ---------- Cuenta: ver contraseña, recuperar, direcciones ---------- */
(function () {
  document.querySelectorAll('[data-ver-pass]').forEach((b) => b.addEventListener('click', () => {
    const input = document.getElementById(b.dataset.verPass);
    if (!input) return;
    const ver = input.type === 'password';
    input.type = ver ? 'text' : 'password';
    b.setAttribute('aria-pressed', ver);
    b.setAttribute('aria-label', ver ? 'Ocultar contraseña' : 'Mostrar contraseña');
  }));
  const rec = document.querySelector('[data-recuperar]');
  if (rec) {
    const login = rec.previousElementSibling && rec.parentElement.querySelector('.tarjeta-acceso:not([data-recuperar])');
    const nota = rec.parentElement.querySelector('.cuenta-acceso__nota');
    const mostrar = (abrir) => { rec.hidden = !abrir; if (login) login.hidden = abrir; if (nota) nota.hidden = abrir; if (abrir) rec.querySelector('input')?.focus(); };
    document.querySelectorAll('[data-abrir-recuperar]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); mostrar(true); }));
    document.querySelectorAll('[data-cerrar-recuperar]').forEach((a) => a.addEventListener('click', () => mostrar(false)));
    if (location.hash === '#recuperar' || !rec.hidden) mostrar(true);
  }
  const dir = document.querySelector('[data-direcciones]');
  if (dir) {
    const abrir = (id, si) => { const f = document.getElementById(id === 'nueva' ? 'direccion-nueva' : 'direccion-editar-' + id); if (f) { f.hidden = !si; if (si) f.querySelector('input')?.focus(); } dir.querySelectorAll(`[data-abrir-direccion="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', si)); };
    dir.querySelectorAll('[data-abrir-direccion]').forEach((b) => b.addEventListener('click', () => abrir(b.dataset.abrirDireccion, true)));
    dir.querySelectorAll('[data-cerrar-direccion]').forEach((b) => b.addEventListener('click', () => abrir(b.dataset.cerrarDireccion, false)));
    dir.querySelectorAll('[data-eliminar-direccion]').forEach((b) => b.addEventListener('click', () => {
      if (!confirm('¿Eliminar esta dirección? No afecta los pedidos ya hechos.')) return;
      if (window.Shopify && Shopify.postLink) Shopify.postLink(b.dataset.url, { parameters: { _method: 'delete' } });
      else { const f = document.createElement('form'); f.method = 'post'; f.action = b.dataset.url; f.innerHTML = '<input type="hidden" name="_method" value="delete">'; document.body.appendChild(f); f.submit(); }
    }));
    dir.querySelectorAll('[data-pais]').forEach((pais) => {
      const prov = pais.closest('.formulario').querySelector('[data-provincia]');
      const pintar = () => {
        const op = pais.options[pais.selectedIndex];
        const provincias = op ? JSON.parse(op.dataset.provinces || '[]') : [];
        prov.innerHTML = '';
        prov.closest('.campo').hidden = provincias.length === 0;
        provincias.forEach(([v, n]) => { const o = document.createElement('option'); o.value = v; o.textContent = n; if (v === prov.dataset.default) o.selected = true; prov.appendChild(o); });
      };
      const def = pais.dataset.default; if (def) Array.from(pais.options).forEach((o) => { if (o.value === def || o.textContent === def) o.selected = true; });
      pais.addEventListener('change', pintar); pintar();
    });
  }
})();

/* ---------- Filtro de talla en coleccion: instantaneo, sin recargar ---------- */
(function () {
  const barra = document.querySelector('[data-chips-talla]');
  if (!barra) return;
  const raiz = barra.closest('.listado') || document;
  const botones = Array.from(barra.querySelectorAll('[data-talla]'));
  const cards = Array.from(raiz.querySelectorAll('.card[data-tallas]'));
  const bloques = Array.from(raiz.querySelectorAll('[data-sin-talla]'));
  const vacio = raiz.querySelector('[data-talla-vacio]');
  const nombre = vacio && vacio.querySelector('[data-talla-nombre]');
  /* Los bloques editoriales y el listado de agotadas se guardan como estaban: con una talla
     elegida estorban, pero al volver a "Todas" tienen que reaparecer igual que al cargar. */
  const estado = new Map();
  bloques.forEach((b) => estado.set(b, b.hidden));

  const aplicar = (talla, escribir_url) => {
    const buscado = talla ? '¦' + talla.toUpperCase() + '¦' : '';
    let visibles = 0;
    cards.forEach((c) => {
      const tiene = !talla || ('¦' + (c.dataset.tallas || '')).toUpperCase().indexOf(buscado) !== -1;
      c.hidden = !tiene;
      if (tiene) visibles += 1;
    });
    bloques.forEach((b) => { b.hidden = talla ? true : estado.get(b); });
    if (vacio) {
      vacio.hidden = !(talla && visibles === 0);
      if (nombre && talla) nombre.textContent = talla;
    }
    botones.forEach((b) => {
      const activo = (b.dataset.talla || '') === (talla || '');
      b.classList.toggle('chip--activo', activo);
      b.setAttribute('aria-pressed', activo ? 'true' : 'false');
    });
    if (escribir_url && window.history && history.replaceState) {
      const url = new URL(window.location.href);
      if (talla) url.searchParams.set('talla', talla); else url.searchParams.delete('talla');
      history.replaceState(null, '', url.toString());
    }
  };

  barra.addEventListener('click', (e) => {
    const b = e.target.closest('[data-talla]');
    if (!b) return;
    aplicar(b.dataset.talla || '', true);
  });

  /* Con ?talla=M en la URL el listado abre ya filtrado: el enlace se puede compartir. */
  const inicial = new URLSearchParams(window.location.search).get('talla');
  if (inicial) aplicar(inicial, false);
})();

/* Las tarjetas nacen del Excel con su foto y su lugar en el menú, pero talla, precio y enlace
   se leen de Shopify al abrir: el filtro de talla solo ofrece lo que se puede comprar hoy.
   Si Shopify no responde, queda lo que trajo el Excel. */
async function sincronizarTarjetas(cards) {
  const r = await fetch('/products.json?limit=250', { credentials: 'same-origin' });
  if (!r.ok) return;
  const productos = (await r.json()).products || [];
  /* Si nada sale comprable, el dato vino mal: se queda lo del Excel. */
  if (!productos.some((p) => p.variants.some((v) => v.available))) return;
  const norm = (x) => (x || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const porHandle = {}, porTitulo = {};
  productos.forEach((p) => { porHandle[p.handle] = p; porTitulo[norm(p.title)] = p; });
  /* Mismo formato que la ficha y el carrito (shop.money_format), así un precio no cambia de aspecto entre secciones. */
  const soles = (n) => (window.qapary && window.qapary.money ? window.qapary.money(Math.round(Number(n) * 100)) : 'S/ ' + Number(n).toFixed(2));
  cards.forEach((card) => {
    const enlace = card.querySelector('.card__ir');
    const titulo = card.querySelector('.card__titulo');
    const handle = card.dataset.handle || (enlace ? (enlace.getAttribute('href') || '').split('/products/')[1] : '');
    const p = porHandle[handle] || porTitulo[norm(titulo && titulo.textContent)];
    const ORDEN_TALLAS = ['6Y', '8Y', '10Y', '12Y', '14Y', '16Y', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
    const lugar = (z) => { const i = ORDEN_TALLAS.indexOf(z); return i < 0 ? 99 : i; };
    const tallas = p ? p.variants.filter((v) => v.available).map((v) => (v.option1 || v.title).toUpperCase().replace(/^2XL$/, 'XXL')).sort((a, b) => lugar(a) - lugar(b)) : [];
    if (!tallas.length) { card.setAttribute('data-sin-stock', ''); card.hidden = true; return; }
    const url = '/products/' + p.handle;
    if (!enlace) {
      /* Tarjeta que venía sin producto en Shopify: se le pone el enlace que faltaba. */
      const a = document.createElement('a');
      a.className = 'card__ir'; a.href = url; a.setAttribute('aria-label', titulo.textContent.trim());
      const foto = card.querySelector('.card__foto');
      foto.querySelectorAll('img').forEach((img) => a.appendChild(img));
      foto.prepend(a);
      titulo.innerHTML = '<a href="' + url + '">' + titulo.textContent.trim() + '</a>';
    }
    /* Nombre del producto en Shopify: el Excel lo traía en mayúsculas y la ficha lo muestra en minúsculas. */
    const tit = card.querySelector('.card__titulo');
    if (tit) { const a = tit.querySelector('a'); (a || tit).textContent = p.title; }
    card.querySelectorAll('.card__ir').forEach((e) => e.setAttribute('aria-label', p.title));
    card.dataset.z = '|' + tallas.join('|') + '|';
    const cinta = card.querySelector('.card__cinta-tallas');
    if (cinta) cinta.innerHTML = tallas.map((z) => '<span class="card__cinta-talla">' + z + '</span>').join('');
    const vendibles = p.variants.filter((v) => v.available);
    const precio = Math.min.apply(null, vendibles.map((v) => parseFloat(v.price)));
    const antes = Math.max.apply(null, vendibles.map((v) => parseFloat(v.compare_at_price) || 0));
    card.dataset.p = precio.toFixed(2);
    const caja = card.querySelector('.card__precio, p.precio');
    if (caja) {
      const nueva = document.createElement('p');
      if (antes > precio) {
        nueva.className = 'card__precio';
        nueva.innerHTML = '<span class="precio">' + soles(precio) + '</span><span class="precio--ancla"><span class="visualmente-oculto">Antes </span>' + soles(antes) + '</span>';
      } else {
        nueva.className = 'precio';
        nueva.textContent = soles(precio);
      }
      caja.replaceWith(nueva);
    }
    const badge = card.querySelector('.badge--oferta');
    if (badge) {
      if (antes > precio) badge.textContent = '-' + Math.round((1 - precio / antes) * 100) + '%';
      else badge.remove();
    }
  });
}

/* ---------- Catalogo: la URL fija el grupo, la barra lateral afina ---------- */
(function () {
  const raiz = document.querySelector('[data-catalogo]');
  if (!raiz) return;
  const q = (s) => raiz.querySelector(s);
  const cards = Array.from(raiz.querySelectorAll('.card--catalogo'));
  const grilla = q('[data-catalogo-grilla]');
  const vacio = q('[data-catalogo-vacio]');
  const cajaTallas = q('[data-catalogo-tallas]');
  const minIn = q('[data-catalogo-min]');
  const maxIn = q('[data-catalogo-max]');
  const limpiar = q('[data-catalogo-limpiar]');
  const minTxt = q('[data-catalogo-min-txt]'), maxTxt = q('[data-catalogo-max-txt]');
  const activo = q('[data-rango-activo]');
  const conteo = q('[data-catalogo-n]');

  /* Lo que decide el menu: grupo, tipo, coleccion o sale. No se toca desde la pagina. */
  const par = new URLSearchParams(window.location.search);
  const g = par.get('g') || '', c = par.get('c') || '', s = par.get('s') || '', t = par.get('t') || '';
  const bonito = (x) => x.replace(/-/g, ' ').replace(/^./, (ch) => ch.toUpperCase());
  const titulos = { mujer: 'Mujer', hombre: 'Hombre' };
  const kicker = q('[data-catalogo-kicker]'), titulo = q('[data-catalogo-titulo]');
  if (s) { kicker.textContent = 'Sale'; titulo.textContent = 'Ofertas del momento'; }
  else if (c && c !== 'todas') { kicker.textContent = 'Colección'; titulo.textContent = bonito(c); }
  else if (c === 'todas') { kicker.textContent = 'Catálogo'; titulo.textContent = 'Colecciones'; }
  else if (g && t) { kicker.textContent = titulos[g] || bonito(g); titulo.textContent = bonito(t); }
  else if (g) { kicker.textContent = 'Catálogo'; titulo.textContent = titulos[g] || bonito(g); }

  const delMenu = (x) => {
    if (g && x.dataset.g !== g) return false;
    if (t && x.dataset.t !== t) return false;
    if (c === 'todas') { if (!x.dataset.c) return false; } else if (c && x.dataset.c !== c) return false;
    if (s && x.dataset.s !== '1') return false;
    return true;
  };
  cards.forEach((x) => { if (!delMenu(x)) x.hidden = true; });
  sincronizarTarjetas(cards).catch(() => {}).then(() => iniciar(cards.filter((x) => delMenu(x) && !x.hasAttribute('data-sin-stock'))));

  function iniciar(base) {

  /* La barra lateral solo ofrece tallas que existen en lo que ya esta en pantalla: una casilla
     que no puede devolver nada es una promesa rota. */
  const ESCALA = ['6Y', '8Y', '10Y', '12Y', '14Y', '16Y', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
  const presentes = [];
  base.forEach((x) => (x.dataset.z || '').split('|').filter(Boolean).forEach((z) => {
    if (presentes.indexOf(z) === -1) presentes.push(z);
  }));
  presentes.sort((a, b) => {
    const i = ESCALA.indexOf(a), j = ESCALA.indexOf(b);
    return (i < 0 ? 99 : i) - (j < 0 ? 99 : j) || a.localeCompare(b);
  });
  presentes.forEach((z) => {
    const l = document.createElement('label');
    l.className = 'filtro-lado__opcion';
    l.innerHTML = '<input type="checkbox" value="' + z + '"> <span>' + z + '</span>';
    cajaTallas.appendChild(l);
  });

  /* El rango se ajusta a lo que hay en pantalla y los dos tiradores se pintan sobre el riel. */
  const precios = base.map((x) => parseFloat(x.dataset.p)).filter((n) => !isNaN(n));
  const TOPE = { min: precios.length ? Math.floor(Math.min.apply(null, precios) / 5) * 5 : 0,
                 max: precios.length ? Math.ceil(Math.max.apply(null, precios) / 5) * 5 : 350 };
  [minIn, maxIn].forEach((i) => { i.min = TOPE.min; i.max = TOPE.max; });
  minIn.value = TOPE.min; maxIn.value = TOPE.max;
  function pintarRango() {
    const a = Math.min(+minIn.value, +maxIn.value), b = Math.max(+minIn.value, +maxIn.value);
    const ancho = TOPE.max - TOPE.min || 1;
    activo.style.left = ((a - TOPE.min) / ancho * 100) + "%";
    activo.style.right = ((TOPE.max - b) / ancho * 100) + "%";
    minTxt.textContent = a; maxTxt.textContent = b;
  }
  pintarRango();
  const orden = () => (raiz.querySelector('input[name="orden-catalogo"]:checked') || {}).value || '';
  const tallasElegidas = () => Array.from(cajaTallas.querySelectorAll('input:checked')).map((i) => i.value);

  function pintar() {
    const zs = tallasElegidas();
    let min = parseFloat(minIn.value), max = parseFloat(maxIn.value);
    if (min > max) { const v = min; min = max; max = v; }
    let n = 0;
    base.forEach((x) => {
      let entra = true;
      if (zs.length && !zs.some((z) => (x.dataset.z || '').indexOf('|' + z + '|') !== -1)) entra = false;
      const precio = parseFloat(x.dataset.p);
      if (!isNaN(min) && precio < min) entra = false;
      if (!isNaN(max) && precio > max) entra = false;
      x.hidden = !entra;
      if (entra) n += 1;
    });
    const o = orden();
    if (o) {
      const visibles = base.filter((x) => !x.hidden);
      visibles.sort((a, b) => {
        if (o === 'az') return a.querySelector('.card__titulo').textContent.localeCompare(b.querySelector('.card__titulo').textContent, 'es');
        const d = parseFloat(a.dataset.p) - parseFloat(b.dataset.p);
        return o === 'precio-desc' ? -d : d;
      });
      visibles.forEach((x) => grilla.appendChild(x));
    }
    conteo.textContent = n;
    vacio.hidden = n > 0;
    grilla.hidden = n === 0;
    limpiar.hidden = !(zs.length || min > TOPE.min || max < TOPE.max || o);
  }

  raiz.addEventListener('change', (e) => { if (e.target.closest('.catalogo__lado')) pintar(); });
  [minIn, maxIn].forEach((i) => i.addEventListener('input', () => { pintarRango(); pintar(); }));
  limpiar.addEventListener('click', () => {
    cajaTallas.querySelectorAll('input:checked').forEach((i) => { i.checked = false; });
    minIn.value = TOPE.min; maxIn.value = TOPE.max; pintarRango();
    const d = raiz.querySelector('input[name="orden-catalogo"][value=""]');
    if (d) d.checked = true;
    pintar();
  });
  pintar();
  }
})();

/* ---------- Filtros en celular: barra fija y hoja desde abajo ---------- */
(function () {
  document.querySelectorAll('.catalogo__cuerpo').forEach((cuerpo) => {
    const lado = cuerpo.querySelector(':scope > .catalogo__lado, :scope > .filtros-lado');
    if (!lado) return;
    cuerpo.classList.add('con-filtros-movil');
    lado.id = lado.id || 'filtros-movil-' + Math.random().toString(36).slice(2, 7);

    const barra = document.createElement('div');
    barra.className = 'filtros-movil__barra';
    barra.innerHTML = '<button type="button" class="filtros-movil__abrir" aria-expanded="false" aria-controls="' + lado.id + '">Filtrar y ordenar</button><span class="filtros-movil__conteo" aria-live="polite"></span>';
    cuerpo.parentNode.insertBefore(barra, cuerpo);
    const abrirBtn = barra.querySelector('.filtros-movil__abrir');
    const conteo = barra.querySelector('.filtros-movil__conteo');

    const cab = document.createElement('div');
    cab.className = 'filtros-movil__cabecera';
    cab.innerHTML = '<p class="h3">Filtrar y ordenar</p><button type="button" class="filtros-movil__cerrar">Cerrar</button>';
    lado.prepend(cab);
    const ver = document.createElement('button');
    ver.type = 'button';
    ver.className = 'boton boton--bloque filtros-movil__ver';
    lado.append(ver);
    const velo = document.createElement('div');
    velo.className = 'filtros-movil__velo';
    velo.hidden = true;
    document.body.append(velo);

    const total = () => {
      if (cuerpo.dataset.conStock) return parseInt(cuerpo.dataset.conStock, 10) || 0;
      const n = document.querySelector('[data-catalogo-n]');
      if (n) return parseInt(n.textContent, 10) || 0;
      return cuerpo.querySelectorAll('.listado__grilla:not(.listado__grilla--agotadas) > .card').length;
    };
    const pintar = () => { const n = total(); conteo.textContent = n + (n === 1 ? ' producto' : ' productos'); ver.textContent = 'Ver ' + n + (n === 1 ? ' producto' : ' productos'); };
    const abrir = () => {
      pintar();
      cuerpo.classList.add('filtros-abiertos'); velo.hidden = false;
      abrirBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      cab.querySelector('button').focus();
    };
    const cerrar = () => {
      if (!cuerpo.classList.contains('filtros-abiertos')) return;
      cuerpo.classList.remove('filtros-abiertos'); velo.hidden = true;
      abrirBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      abrirBtn.focus();
    };
    abrirBtn.addEventListener('click', abrir);
    cab.querySelector('button').addEventListener('click', cerrar);
    ver.addEventListener('click', cerrar);
    velo.addEventListener('click', cerrar);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') cerrar(); });
    const n = document.querySelector('[data-catalogo-n]');
    if (n && 'MutationObserver' in window) new MutationObserver(pintar).observe(n, { childList: true, characterData: true, subtree: true });
    pintar();
  });
})();

/* ---------- Cinta de pijamas en celular: carrusel a mano con flechas, contador y avance suave ---------- */
(function () {
  const tactil = window.matchMedia('(max-width: 767px), (hover: none)');
  const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-cinta-tactil]').forEach((ventana) => {
    const seccion = ventana.closest('.cinta');
    const items = Array.from(ventana.querySelectorAll('.cinta__lista:not([aria-hidden]) > .cinta__item'));
    const actual = seccion && seccion.querySelector('[data-cinta-actual]');
    if (!items.length || !seccion) return;
    const indice = () => {
      const x = ventana.scrollLeft;
      let mejor = 0, dist = Infinity;
      items.forEach((it, i) => { const d = Math.abs(it.offsetLeft - items[0].offsetLeft - x); if (d < dist) { dist = d; mejor = i; } });
      return mejor;
    };
    const ir = (i) => {
      const total = items.length, j = (i + total) % total;
      ventana.scrollTo({ left: items[j].offsetLeft - items[0].offsetLeft, behavior: quieto ? 'auto' : 'smooth' });
    };
    seccion.querySelectorAll('[data-cinta-ir]').forEach((b) => b.addEventListener('click', () => { pausar(); ir(indice() + Number(b.dataset.cintaIr)); }));
    let t = 0;
    ventana.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => { if (actual) actual.textContent = indice() + 1; }, 80); }, { passive: true });

    /* Avanza sola cada 5 s mientras se ve; un toque la detiene 10 s. Con movimiento reducido no avanza. */
    let reloj = 0, hasta = 0, visible = false;
    const pausar = () => { hasta = Date.now() + 10000; };
    ['touchstart', 'pointerdown', 'wheel'].forEach((ev) => ventana.addEventListener(ev, pausar, { passive: true }));
    const tic = () => { if (tactil.matches && visible && !quieto && Date.now() > hasta && !document.hidden) ir(indice() + 1); };
    if ('IntersectionObserver' in window) new IntersectionObserver((e) => { visible = e[0].isIntersecting; }, { threshold: 0.5 }).observe(ventana);
    reloj = setInterval(tic, 5000);
  });
})();

/* ---------- Best Sellers: tallas, precio y nombre leídos de Shopify, como el catálogo ---------- */
(function () {
  document.querySelectorAll('.destacados').forEach((sec) => {
    const cards = Array.from(sec.querySelectorAll('.card--catalogo'));
    if (cards.length) sincronizarTarjetas(cards).catch(() => {});
  });
})();

/* ---------- Pie en celular: Tienda, Ayuda y Legal plegables; Escríbenos queda abierta ---------- */
(function () {
  const movil = window.matchMedia('(max-width: 767px)');
  const cols = Array.from(document.querySelectorAll('.footer__col')).filter((c) => !c.classList.contains('footer__col--marca') && c.id !== 'contacto');
  cols.forEach((col, i) => {
    const titulo = col.querySelector(':scope > .footer__titulo');
    if (!titulo) return;
    const id = col.id || 'pie-col-' + i;
    col.id = id;
    col.classList.add('footer__col--plegable');
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'footer__plegar'; b.textContent = titulo.textContent.trim();
    b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-controls', id);
    col.prepend(b);
    /* Con Legal plegada, el ícono del Libro de Reclamaciones queda como el acceso visible: se vuelve un enlace con nombre. */
    const libro = col.querySelector(':scope > .footer__libro');
    const pintarLibro = (abierta) => {
      if (!libro) return;
      if (abierta || !movil.matches) { libro.setAttribute('aria-hidden', 'true'); libro.tabIndex = -1; libro.removeAttribute('aria-label'); }
      else { libro.removeAttribute('aria-hidden'); libro.tabIndex = 0; libro.setAttribute('aria-label', 'Libro de Reclamaciones'); }
    };
    pintarLibro(false);
    movil.addEventListener('change', () => pintarLibro(col.classList.contains('footer__col--abierta')));
    b.addEventListener('click', () => {
      const abierta = col.classList.toggle('footer__col--abierta');
      b.setAttribute('aria-expanded', abierta ? 'true' : 'false');
      pintarLibro(abierta);
    });
  });
})();
